import type { DefinitionNode, DocumentNode } from 'graphql';
import { Kind } from 'graphql';

export const createDocumentNode = (definitions: DefinitionNode[]): DocumentNode => ({
  kind: Kind.DOCUMENT,
  definitions,
});
